import React from 'react'

import {
  Grid,
  Panel,
  Button,
  Bullet,
  FlexBox,
  Columns,
  IconFont,
  AlignItems,
  FunnelPage,
  AppWrapper,
  InfluxColors,
  ComponentSize,
  FlexDirection,
  ComponentColor,
  Heading,
  HeadingElement,
} from '@influxdata/clockface'

import InfluxDataLogo from 'js/components/InfluxDataLogo'
import FunnelHeader from '../shared/FunnelHeader'
import FunnelSubheader from '../shared/FunnelSubheader'

interface Props {
  email: string
}

const InviteExpired = ({email}: Props): JSX.Element => {
  return (
    <AppWrapper type="funnel">
      <FunnelPage logo={<InfluxDataLogo />}>
        <Grid.Row>
          <Grid.Column
            widthSM={Columns.Ten}
            offsetSM={Columns.One}
            widthMD={Columns.Eight}
            offsetMD={Columns.Two}
          >
            <FlexBox
              direction={FlexDirection.Column}
              alignItems={AlignItems.Center}
              margin={ComponentSize.Large}
            >
              <FunnelHeader text="This invitation has Expired" />
              <FunnelSubheader
                text={`This invitation to ${email} has expired`}
              />
              <Panel style={{maxWidth: '600px'}}>
                <Panel.SymbolHeader
                  symbol={
                    <Bullet
                      glyph={IconFont.AlertTriangle}
                      color={InfluxColors.Curacao}
                    />
                  }
                  title={
                    <Heading element={HeadingElement.H3}>
                      This invitation has expired
                    </Heading>
                  }
                  size={ComponentSize.Medium}
                />
                <Panel.Body size={ComponentSize.Medium}>
                  <FlexBox
                    direction={FlexDirection.Column}
                    margin={ComponentSize.Medium}
                    alignItems={AlignItems.FlexStart}
                    className="marketplace-splash--buttons"
                  >
                    <p>
                      {' '}
                      Request a new invitation from your organization
                      admin.{' '}
                    </p>
                    <p> Or create your own organization with a new account. </p>
                  </FlexBox>
                </Panel.Body>
                <Panel.Footer size={ComponentSize.Medium}>
                  <a href="/signup">
                    <Button
                      text="Create new Account"
                      size={ComponentSize.Large}
                      color={ComponentColor.Default}
                    />
                  </a>
                </Panel.Footer>
              </Panel>
            </FlexBox>
          </Grid.Column>
        </Grid.Row>
      </FunnelPage>
    </AppWrapper>
  )
}

export default InviteExpired
